import type { FunctionComponent } from "react";
import type { ConversationMessageApiModel as ChatMessageType } from "@noa/api-core";
import { useActionDescription } from "@noa/client-store";
import { ChatActionDescription } from "./chat-action-description";
import { ChatMessage } from "./chat-message";
import { ChatStatus } from "./chat-status";
import { ChatWarmupNotice } from "./chat-warmup-notice";
import { useSyncConversationsHistory } from "@noa/ui";
import { useAutoScrollToBottom } from "~/hooks/chat/use-auto-scroll-to-bottom";

interface MessagesListProps {
  messages: ChatMessageType[];
}

export const MessagesList: FunctionComponent<MessagesListProps> = ({ messages }) => {
  const hasMessages = messages.length > 0;
  const actionDescription = useActionDescription();
  const { containerRef, messagesEndRef } = useAutoScrollToBottom([messages, actionDescription]);

  useSyncConversationsHistory();

  return (
    <div ref={containerRef} className="always-show-scrollbar flex flex-1 flex-col gap-3 overflow-y-scroll pb-6">
      {/* In the greeting's place: whatever is listed below it was sent while waiting. */}
      <ChatWarmupNotice />

      {messages.map((message, index) => (
        <ChatMessage key={index} index={index} chatMessage={message} isLastMessage={index === messages.length - 1} />
      ))}

      <ChatActionDescription />

      {hasMessages && <ChatStatus />}

      <div ref={messagesEndRef} />
    </div>
  );
};
